<template>
    <div v-if="isLeserserviceOrHigher" class="set-password">
        <div>
            <v-tooltip bottom v-if="alternativeBtn">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="open" v-bind="$attrs" class="set-password__activator">Passwort ändern</v-btn>
                </template>
                <div class="max-width-btn">
                    Bearbeiten des Passworts ohne das Versenden einer Email.
                </div>
            </v-tooltip>
            <v-tooltip left v-if="!alternativeBtn">
                <template #activator="{ on }">
                    <v-btn v-bind="$attrs" text icon color="primary" @click="open" v-on="on">
                        <v-icon v-bind="$attrs">mdi-key-variant</v-icon>
                    </v-btn>
                </template>
                <span>Neues Passwort setzen</span>
            </v-tooltip>
        </div>
        <v-dialog
            :value="showDialog"
            max-width="500"
            persistent
        >
            <v-card>
                <v-card-title class="headline" primary-title>
                    Neues Passwort setzen
                </v-card-title>
                <v-card-text>
                    <div>
                        <LabelValue label="Name" :value="fullname" />
                        <LabelValue label="Email" :value="email" />
                        <v-form v-model="passwordValid" class="mt-4">
                            <v-text-field
                                :value="password"
                                @input="setPassword"
                                :rules="passwordRules"
                                label="Neues Passwort"
                                :disabled="loading"
                                @keyup.enter="setPw"
                                required
                            ></v-text-field>
                        </v-form>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" outlined @click="abbort" :disabled="loading">Abbrechen</v-btn>
                    <v-btn color="success" outlined :loading="loading" :disabled="loading || !passwordValid" @click="setPw">Passwort setzen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters,
} from 'vuex';
import LabelValue from '@/components/LabelValue.vue';

export default {
    name: 'SetPassword',
    props: {
        ssoId: String,
        fullname: String,
        email: String,
        alternativeBtn: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        LabelValue,
    },
    data() {
        return {
            passwordValid: false,
            passwordRules: [
                v => !!v || 'Neues Passwort darf nicht leer sein.',
                v => v.length >= 6 || 'Neues Passwort muss mindestens 6 Zeichen '
                    + 'lang sein.',
            ],
        };
    },
    computed: {
        ...mapState('customerSetPassword', [
            'loading',
            'showDialog',
            'password',
        ]),
    },
    methods: {
        open() {
            this.setShowDialog(true);
        },
        abbort() {
            this.resetState();
            this.info('Das setzen des Passworts wurde abgebrochen.');
        },
        setPw() {
            if (!this.passwordValid) {
                return;
            }
            this.setNewPassword(this.ssoId)
                .then(() => {
                    this.success('Das Passwort wurde erfolgreich aktualisiert.');
                })
                .catch(() => {
                    this.error('Das Passwort konnte nicht geändert werden.');
                });
        },
        ...mapActions('customerSetPassword', ['setNewPassword']),
        ...mapMutations('customerSetPassword', ['setPassword', 'resetState', 'setShowDialog']),
        ...mapMutations('snackbar', [
            'error',
            'success',
            'info',
        ]),
        ...mapGetters(['isLeserserviceOrHigher']),
    },
};
</script>

<style scoped lang="scss">
    .set-password__activator {
        width: 100%;
    }
</style>
